/**
 * Display cart ID matching the label on cart cards (strip cart_instance_ prefix).
 * @param {string} cartInstanceId
 * @returns {string}
 */
export function formatCartIdForDisplay(cartInstanceId) {
  if (!cartInstanceId || typeof cartInstanceId !== 'string') {
    return '';
  }
  return cartInstanceId.replace(/^cart_instance_/, '');
}

/**
 * Build human-readable QR payload for pickup verification.
 * @param {{ cartId?: string, userName?: string }} params
 * @returns {string}
 */
export function buildPickupQrPayload({ cartId, userName } = {}) {
  const displayCartId = formatCartIdForDisplay(cartId) || String(cartId || '').trim() || 'Unknown';
  const displayName = (userName && String(userName).trim()) || 'User';

  return [
    'Pack My Cart Pickup',
    `Cart ID: ${displayCartId}`,
    `Name: ${displayName}`,
  ].join('\n');
}
